import { Row, Col } from "antd";
import { withTranslation } from "react-i18next";
import { JackInTheBox } from "react-awesome-reveal";
import { Button } from "../../common/Button";
import { VideoBlockSection, Content, ContentWrapper, Video, VideoContainer } from "./styles";


const VideoBlock = () => {
  const scrollTo = (id: string) => {
    const element = document.getElementById(id) as HTMLDivElement;
    element.scrollIntoView({
      behavior: "smooth",
    });
  };
  return (
    <VideoBlockSection>
     
     <VideoContainer>
            <Video src="https://www.youtube.com/embed/hDGB7vp9qEU" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></Video>
      </VideoContainer>

    </VideoBlockSection>
  );
};

export default withTranslation()(VideoBlock);
